import { useEffect } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _RequestNeed } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../theme/Component/BasicTable";


interface Props {
    _idRequest: number;
}

export const HistoryRequesNeed = ({ _idRequest }: Props) => {

    const { instance, lista, setLista } = useDataBean(_RequestNeed);

    useEffect(() => {
        getLista();
    }, [_idRequest])

    const getLista = () => {
        instance.getRequestNeedHistoryCatalogRender({ IDRequestNeed: _idRequest }, null, null).then(
            (resp) => {
                let x = resp;
                x.forEach(element => {
                    element.DataBeanProperties.EntityName = (element.DataBeanProperties.IDEmployee ?
                        `${element.DataBeanProperties.Name1} ${element.DataBeanProperties.Name2} ${element.DataBeanProperties.Surname1} ${element.DataBeanProperties.Surname2}`
                        :
                        "N/A"
                    )
                });
                setLista(x)
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDRequestNeedHistory', visible: true },
        { title: 'Usuario', property: 'EntityName', visible: true },
        { title: 'Observaciones', property: 'Observation', visible: true },
        { title: 'Fecha de Evento', property: 'Since', visible: true },
    ]

    return (
        <div className="row">
            <BasicTable body={lista} head={head} rowSet={setLista} />
        </div>
    )

}